/* CHEZ NOUS — bascule d'encre de la barre flottante.
   Wales Bonner et Jacquemus gardent une barre transparente d'un bout à l'autre :
   leurs héros sont clairs. Ici le hero est une photo pleine page, donc la barre
   est blanche au-dessus de lui puis passe à l'encre. Le logo du thème est blanc,
   la classe cn-pose lui applique invert(1).

   Historique des deux essais précédents, pour qui reprendra ce fichier :
   1. IntersectionObserver sur une sentinelle : ne se déclenchait pas de façon
      fiable une fois le groupe d'en-tête passé en position fixed.
   2. requestAnimationFrame pour lisser : le rAF est étranglé dès que l'onglet
      n'est pas au premier plan, et le verrou « enCours » restait bloqué à true,
      figeant la bascule pour de bon.
   Bascule synchrone dans un écouteur passif : une comparaison et un classList,
   c'est moins cher qu'un rAF et ça ne peut pas se bloquer. */
(function () {
  var hero = document.querySelector('#MainContent > .shopify-section');
  if (!hero) return;

  function maj() {
    var seuil = Math.max(0, hero.offsetHeight - 90);
    document.documentElement.classList.toggle('cn-pose', window.scrollY > seuil);
  }

  maj();
  window.addEventListener('scroll', maj, { passive: true });
  window.addEventListener('resize', maj);
  window.addEventListener('load', maj);
})();